import React from 'react';
import { Box, Grid } from '@mui/material';
import {
  SmartToy as AiMockIcon,
  Groups as PeerIcon,
  VerifiedUser as ExpertIcon,
  Assessment as FeedbackIcon,
  Videocam as RecordingIcon,
  Description as ResumeIcon,
} from '@mui/icons-material';
import SectionContainer from '../shared/SectionContainer';
import FeatureCard from '../shared/FeatureCard';
import LandingCtaButton from '../shared/LandingCtaButton';
import { CANDIDATE_FEATURES, CTAS } from '../landingContent';

const CANDIDATE_ICONS = [
  AiMockIcon,
  PeerIcon,
  ExpertIcon,
  FeedbackIcon,
  RecordingIcon,
  ResumeIcon,
];

const CandidateFeaturesSection = () => (
  <SectionContainer
    id="candidates"
    title="Prepare Smarter. Interview Better."
    subtitle="Everything candidates need to search roles, sharpen skills, and walk into interviews with confidence."
    titleId="candidates-heading"
  >
    <Grid container spacing={3}>
      {CANDIDATE_FEATURES.map((feature, index) => {
        const Icon = CANDIDATE_ICONS[index];
        return (
          <Grid item xs={12} sm={6} md={4} key={feature.title}>
            <FeatureCard
              title={feature.title}
              description={feature.description}
              icon={<Icon sx={{ fontSize: 36 }} />}
            />
          </Grid>
        );
      })}
    </Grid>
    <Box sx={{ textAlign: 'center', mt: 5 }}>
      <LandingCtaButton
        to={CTAS.practice.to}
        label={CTAS.practice.label}
        variant={CTAS.practice.variant}
      />
    </Box>
  </SectionContainer>
);

export default CandidateFeaturesSection;
